/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import{cloneAndDecodeGeometry as r}from"../CIMCursor.js";import{getPlacementOperator as t}from"../CIMOperators.js";class e{static getPlacement(e,o,s){const c=t(o);if(!c)return null;const n=r(e);return c.execute(n,o,s)}}export{e as CIMMarkerPlacementHelper};
